export default __webpack_public_path__ + "static/media/dream-prize.aecedc9f.jpeg";